import { MoreOutlined } from '@ant-design/icons';
import { Button, Dropdown, Modal, Typography } from 'antd';
import React, { useContext, useState } from 'react';

import { CLOSE, FRONT_WARNING } from '@app/constants';
import { useUserPrint } from '@app/hooks';
import { HistoryModalContent } from '@app/pages/TasksList/components';
import type { NTasksList } from '@app/pages/TasksList/types/TasksList.types';
import { NotificationContext } from '@app/providers';
import { handleCatchError } from '@app/services';
import { useLazyGetCrmTaskHistoryByIdQuery } from '@app/services/rtkQuery/CrmTasks/api';
import type { NActionsHistory } from '@app/types';

const { Title } = Typography;

export const HistoryModal: React.FC<NTasksList.HistoryModalProps> = ({
  isModalOpen,
  historyModalTitle,
  handleCancelHistoryModal,
  currentTaskId,
  dropdownMenu = [],
}) => {
  const [historyData, setHistoryData] = useState<
    NActionsHistory.ModelActionHistory[]
  >([]);

  const { activeBranchId } = useUserPrint();
  const { showNotification } = useContext(NotificationContext);

  const [getCrmTaskHistory, { isLoading }] =
    useLazyGetCrmTaskHistoryByIdQuery();

  const handleDialogOpening = async (isOpened: boolean): Promise<void> => {
    if (!isOpened) {
      return;
    }

    if (!currentTaskId) {
      return showNotification('Не найден ID задачи', FRONT_WARNING);
    }

    const { data, error } = await getCrmTaskHistory({
      id: currentTaskId,
      ActiveBranchId: activeBranchId,
    });

    if (error) {
      return showNotification(handleCatchError(error));
    }

    setHistoryData(data || []);
  };

  const title = (
    <div className="task-modal-title">
      <Title level={5}>{historyModalTitle}</Title>
      <Dropdown menu={{ items: dropdownMenu }}>
        <MoreOutlined />
      </Dropdown>
    </div>
  );

  return (
    <Modal
      afterOpenChange={(isOpened) => handleDialogOpening(isOpened)}
      open={isModalOpen}
      title={title}
      className="task-modal"
      onCancel={handleCancelHistoryModal}
      footer={
        <Button type="primary" onClick={handleCancelHistoryModal}>
          {CLOSE}
        </Button>
      }
    >
      <HistoryModalContent isLoading={isLoading} historyData={historyData} />
    </Modal>
  );
};
